// extracted by mini-css-extract-plugin
module.exports = {"contactList":"contactList_contactList__a1pDw"};